import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import React, { useRef, useEffect, useMemo } from 'react';
import { useStyles, StyleSheet } from '@rexlabs/styling';
import TabBarDefault from './tab-bar';
var defaultStyles = StyleSheet({
  container: {
    width: '100%'
  },
  tabHidden: {
    display: 'none'
  }
});
var displayName = 'Tabs';
export function Tabs(_ref) {
  var children = _ref.children,
      items = _ref.items,
      activeTab = _ref.activeTab,
      alwaysRenderAll = _ref.alwaysRenderAll,
      _ref$keepRenderedTabs = _ref.keepRenderedTabs,
      keepRenderedTabs = _ref$keepRenderedTabs === void 0 ? true : _ref$keepRenderedTabs,
      overflowIntoActionMenu = _ref.overflowIntoActionMenu,
      onChange = _ref.onChange,
      _ref$TabBar = _ref.TabBar,
      TabBar = _ref$TabBar === void 0 ? TabBarDefault : _ref$TabBar,
      rest = _objectWithoutProperties(_ref, ["children", "items", "activeTab", "alwaysRenderAll", "keepRenderedTabs", "overflowIntoActionMenu", "onChange", "TabBar"]);

  var s = useStyles(defaultStyles, displayName);
  var rendered = useRef([]);
  useEffect(function () {
    var _context;

    if (!_includesInstanceProperty(_context = rendered.current).call(_context, activeTab)) {
      rendered.current.push(activeTab);
    }
  }, [activeTab]);
  var tabs = useMemo(function () {
    return _mapInstanceProperty(items).call(items, function (_ref2) {
      var _context2;

      var name = _ref2.name,
          tabProps = _ref2.tabProps,
          _ref2$Tab = _ref2.Tab,
          Tab = _ref2$Tab === void 0 ? function () {
        return null;
      } : _ref2$Tab;
      var isActive = name === activeTab;
      var hasBeenRendered = keepRenderedTabs ? _includesInstanceProperty(_context2 = rendered.current).call(_context2, name) : false;
      var shouldBeRendered = alwaysRenderAll || hasBeenRendered || isActive;

      if (!shouldBeRendered) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", _extends({}, s('tab', {
        tabHidden: !isActive
      }), {
        key: name,
        role: "tabpanel",
        "aria-hidden": !isActive
      }), /*#__PURE__*/React.createElement(Tab, _extends({}, tabProps, {
        isActive: isActive
      })));
    });
  }, // eslint-disable-next-line
  [activeTab, alwaysRenderAll, items, keepRenderedTabs]);
  return /*#__PURE__*/React.createElement("div", _extends({}, s.with('container')(rest), rest), /*#__PURE__*/React.createElement(TabBar, {
    activeTab: activeTab,
    items: items,
    overflowIntoActionMenu: overflowIntoActionMenu,
    onChange: onChange
  }), /*#__PURE__*/React.createElement("div", s('tabs'), children ? children({
    tabs: tabs
  }) : tabs));
}
Tabs.displayName = displayName;
export default Tabs;